
export const TCOVehicles = [
    {
        duration: "12 mois",
        immat: "AA-123-AA",
        marque: "RENAULT",
        modele: "CLIO",
        cat: "VP",
    },
    {
        duration: "12 mois",
        immat: "AA-123-AA",
        marque: "RENAULT",
        modele: "CLIO",
        cat: "VP",
    },
];

export const AllVehicles = [
    { label: "AA-123-AA", value: "AA-123-AA" },
    { label: "AA-124-AA", value: "AA-124-AA" },
    { label: "AA-125-AA", value: "AA-125-AA" },
    { label: "AA-126-AA", value: "AA-126-AA" },
];

export const VehicleSearchData = TCOVehicles.map((item) => ({
    label: `${item.immat} ${item.marque} ${item.modele}`,
}));
